export class Council {
    name: string;
    id: number;
    initials: string;
    code: string;
}



